var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'rejectreason-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      searchContent: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    rejectReasons () {
      return this.$store.getters.rejectReasonList
    },
    nextPage () {
      return this.$store.getters.rejectReasonListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.rejectReasonListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {'reject_reason': this.searchContent}
      this.$store.dispatch('REJECT_REASON_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    goRejectReasonNew: function () {
      this.$router.push({ path: '/reject_reasons/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goRejectReasonEdit: function(rejectReasonId) {
      this.$router.push({ path: '/reject_reasons/' + rejectReasonId + '/edit'})
    },
    rejectReasonDelete: function(rejectReasonId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('REJECT_REASON_DELETE',  {id: rejectReasonId, callback: this.onSaved})
      }
    },
    content: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    },
    half: function () {
      this.searchContent = utils.emHalf(this.searchContent)
    },
    onSaved: function (result) {
      this.$router.push('/reject_reasons')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/rejectreason-list.js